import type { EffectDefinition, EffectContext } from './types'

interface Ember {
  x: number
  y: number
  vx: number
  vy: number
  radius: number
  life: number
  maxLife: number
  r: number
  g: number
  b: number
}

function createEmber(width: number, height: number): Ember {
  const life = 1.5 + Math.random() * 2
  const colorRand = Math.random()
  let r: number, g: number, b: number
  if (colorRand < 0.4) {
    r = 255; g = 100 + Math.random() * 60; b = 20
  } else if (colorRand < 0.7) {
    r = 255; g = 160 + Math.random() * 60; b = 40
  } else {
    r = 255; g = 60 + Math.random() * 40; b = 10
  }
  return {
    x: Math.random() * width,
    y: height + Math.random() * 20,
    vx: (Math.random() - 0.5) * 40,
    vy: -(60 + Math.random() * 100),
    radius: 1.5 + Math.random() * 3,
    life,
    maxLife: life,
    r, g, b
  }
}

export const fire: EffectDefinition = {
  id: 'fire',
  name: 'Fire',

  init(ctx: EffectContext) {
    const count = Math.floor((ctx.width * ctx.height) / 4000)
    const embers: Ember[] = []
    for (let i = 0; i < count; i++) {
      const ember = createEmber(ctx.width, ctx.height)
      ember.y = ctx.height * 0.5 + Math.random() * ctx.height * 0.5
      ember.life = Math.random() * ember.maxLife
      embers.push(ember)
    }
    return embers
  },

  update(state: unknown, ctx: EffectContext) {
    const embers = state as Ember[]
    const dt = ctx.deltaTime / 1000
    for (const ember of embers) {
      ember.x += ember.vx * dt
      ember.y += ember.vy * dt
      ember.vx += (Math.random() - 0.5) * 20 * dt
      ember.life -= dt
      if (ember.life <= 0) {
        Object.assign(ember, createEmber(ctx.width, ctx.height))
      }
    }
  },

  draw(state: unknown, ctx: EffectContext) {
    const embers = state as Ember[]
    const { ctx: c } = ctx
    for (const ember of embers) {
      const alpha = Math.max(0, (ember.life / ember.maxLife) * 0.6)
      c.beginPath()
      c.arc(ember.x, ember.y, ember.radius, 0, Math.PI * 2)
      c.fillStyle = `rgba(${ember.r}, ${ember.g}, ${ember.b}, ${alpha})`
      c.fill()
    }
  }
}
